import { useState } from 'react';

//components
import ContentModal from  '@/components/modals/widgetPanel/ContentModals/ContentModal';
import WidgetButton from './WidgetButton/WidgetButton';
import { BasicTooltip } from 'thrive-components';

//enums
import { WidgetType } from  '@/interfaces/widgetPanel';



const DuplicateWidget = () => {
    const [showDuplicateModal, setShowDuplicateModal] = useState<boolean>(false)

    return (
        <BasicTooltip 
            children={
                <div className="widget-panel-item">
                    <WidgetButton type={WidgetType.DUPLICATE} onClick={() => setShowDuplicateModal(true)} />
                    
                    {showDuplicateModal &&
                        <ContentModal
                            setShowModal={setShowDuplicateModal}
                            isDuplicateContent={true}
                        />
                    }
                </div>
            } 
            className='above widget-item-tooltip'
            text={'Create a fresh duplicate of an existing page'} 
        />
    )
}
export default DuplicateWidget